import React from "react";

// Customizable Area Start
import { TextField, Button, Checkbox, FormControlLabel, Box, Typography, Select, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { backgroundImage, logoImage } from "./assets";
import Twemoji from 'react-twemoji';
// Customizable Area End
import EmailAccountRegistrationController, {
  Props,
} from "./EmailAccountRegistrationController";


export default class EmailAccountRegistration extends EmailAccountRegistrationController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  render() {
    return (
      <Box sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
      }}>
        <Box sx={{
          maxWidth: '50%',
          flex: 1,
          padding: '32px 42px',
          alignItems: 'center',
          flexDirection: 'column',
          display: 'flex',
        }}>
          <Box sx={{ marginBottom: '32px', alignSelf: 'flex-start', cursor: 'pointer' }}>
            <img
              onClick={() => this.props.navigation.navigate("LandingPage")}
              alt="Logo"
              src={logoImage}
              style={{ height: '24px', width: '148px', }}
            />
          </Box>

          <Box
            sx={{
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {this.state.privacyPolicyError && (
              <Box
                sx={{
                  backgroundColor: "#FEE2E2",
                  color: "#f05050",
                  padding: "20px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  minWidth: "100%",
                  position: "relative",
                  borderLeft: "4px solid #dc2626",
                  borderTopLeftRadius: 4,
                  borderBottomLeftRadius: 4,
                }}
              >
                <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "18px", font: "inter" }}>
                  {this.state.privacyPolicyError}
                </Typography>

                {/* Add cross icon */}
                <Box
                  onClick={this.closePrivacyError}
                  sx={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <Typography sx={{ fontSize: "20px", color: "#dc2626", cursor: "pointer", }}>
                    ×
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>

          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '340px',
            margin: 'auto',
          }}>



            <Typography
              variant="h4"
              sx={{
                textAlign: 'center',
                fontSize: '22px',
                fontWeight: 700,
                letterSpacing: '-0.33px',
                color: '#2a1c1c',
                marginBottom: '40px'
              }}
            >
              Sign up
            </Typography>

            {/* Email Field */}
            <Box sx={{ marginBottom: "30px" }}>
              <Typography sx={{ fontWeight: 700, fontSize: "14px", marginBottom: "8px" }}>
                Email Address
              </Typography>
              <TextField
                data-test-id="txtInputEmail"
                value={this.state.emailAddress}
                onChange={this.handleEmailAddressChange}
                fullWidth
                placeholder="Your Email"
                error={!!this.state.emailError}
                helperText={this.state.emailError}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: this.state.emailError ? "red" : "#cbd5e1",
                      borderRadius: "12px",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    marginLeft: "0",
                  },
                }}
              />
            </Box>

            {/* Phone Number Field */}
            <Box sx={{ marginBottom: "30px" }}>
              <Typography sx={{ fontSize: "14px", fontWeight: 700, marginBottom: "8px" }}>
                Phone number
              </Typography>
              <Box sx={{ gap: "8px", display: "flex", }}>
                <Select
                  data-test-id="countryCodeSelect"
                  onChange={this.handleCountryCodeChange}
                  value={this.state.countryCodeSelected}
                  defaultValue="DE"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#fff",
                    minWidth: "76px",
                    height: "44px",
                    padding: "27px 0px",
                    borderRadius: "12px",
                    lineHeight: 'normal',
                    border: "1px solid #cbd5e1",
                    '& .MuiSvgIcon-root': {
                      color: 'black',
                    },
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                  renderValue={(value) => {
                    const country = this.state.flagResponse.response.find(
                      (country) => country.id === value
                    );
                    return country ? (
                      <Twemoji options={{ folder: 'svg', ext: '.svg' }}>
                        <span
                          style={{
                            marginRight: "50px",
                            borderRadius: "0",
                            fontSize: "28px",
                            position: "relative",
                            lineHeight: 1,
                            verticalAlign: 'middle',
                          }}
                        >
                          {country.attributes.emoji_flag}
                        </span>
                      </Twemoji>
                    ) : (
                      value
                    );
                  }}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',

                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',

                    },
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        overflow: 'auto',
                        width: 345,

                      },
                    },
                  }}
                >
                  {this.state.flagResponse.response.map((country) => (
                    <MenuItem key={country.id} value={country.id} sx={{
                      display: "flex", alignItems: "center",
                      '& img.emoji': {
                        height: '24px',
                        width: '24px',

                      },
                    }}>
                      <Twemoji options={{ folder: 'svg', ext: '.svg' }}>
                        <span style={{ fontSize: "24px", marginRight: "8px", position: "relative" }}>{country.attributes.emoji_flag}</span>
                      </Twemoji>
                      {country.attributes.name}
                    </MenuItem>
                  ))}
                </Select>

                <TextField
                  data-test-id="txtInputPhoneNumber"
                  onKeyDown={this.preventInvalidInput}
                  value={this.formatPhoneNumber(this.state.phoneNumber)}
                  onChange={this.handlePhoneNumberChange}
                  placeholder="Phone number"
                  fullWidth
                  helperText={this.state.phoneError}
                  inputProps={{ maxLength: 12 }}
                  error={!!this.state.phoneError}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderRadius: "12px",
                        borderColor: this.state.phoneError ? "red" : "#cbd5e1",
                      },
                    },
                    "& .MuiFormHelperText-root": {
                      marginLeft: "-85",
                    },
                    height: "44px",
                  }}
                />
              </Box>
            </Box>

            <FormControlLabel
              data-test-id="checkboxPrivacyPolicy"
              control={<Checkbox
                data-test-id="checkboxPrivacyPolicy"
                checked={this.state.privacyPolicyAccepted}
                onChange={this.handlePrivacyPolicyCheckBoxChange}
                sx={{
                  '&.Mui-checked': { color: '#000' },
                  padding: '0 9px 0 0',
                  marginTop: '-1px',
                  alignSelf: 'flex-start',
                  '& .MuiCheckbox-root': { borderRadius: '12px' }
                }} />}
              label={
                <Typography
                  data-test-id="PrivacyPolicy"
                  sx={{
                    fontSize: '14px',
                    lineHeight: '1.2',
                    marginTop: '1px',
                  }}>
                  I agree with <u data-test-id="linkPrivacyPolicy" onClick={this.handlePrivacyPolicyClick}>Privacy Policy</u> and <u data-test-id="linkTermsConditions" onClick={this.handleTermsAndConditionsClick}>Terms and Conditions</u>
                </Typography>
              }
              onClick={(e: React.MouseEvent) => {
                if (!(e.target as Element).closest('input[type="checkbox"], .MuiCheckbox-root')) {
                  e.preventDefault();
                }
              }}
              sx={{
                marginBottom: '20px',
                alignItems: 'flex-start',
                marginLeft: '0px',
                '& .MuiFormControlLabel-label': {
                  marginLeft: '4px',
                }
              }}
            />

            <Button
              data-test-id="btnVerify"
              fullWidth
              variant="contained"
              disabled={!this.state.emailAddress || !!this.state.emailError ||
                !this.state.phoneNumber || !!this.state.phoneError}
              sx={{
                textTransform: 'none',
                backgroundColor: this.state.emailAddress && !this.state.emailError &&
                  this.state.phoneNumber && !this.state.phoneError ? '#000' : '#f1f5f9',
                color: this.state.emailAddress && !this.state.emailError &&
                  this.state.phoneNumber && !this.state.phoneError ? '#fff' : '#64748b',
                fontWeight: 700,
                fontSize: '16px',
                padding: '10px 16px',
                marginBottom: '20px',
                borderRadius: '12px',
                '&:hover': {
                  backgroundColor: this.state.emailAddress && !this.state.emailError &&
                    this.state.phoneNumber && !this.state.phoneError ? '#333' : '#e2e8f0',
                }
              }}
              onClick={this.handleVerifyButtonClick}
            >
              Verify
            </Button>

            <Box sx={{ textAlign: 'center' }}>
              <Typography component="span" sx={{ fontSize: '16px' }}>
                Already have an account?{' '}
              </Typography>
              <Typography
                onClick={() => this.props.navigation.navigate("EmailAccountLoginBlock")}
                component="span"
                sx={{
                  fontSize: '16px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Log in
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '50%',
          position: 'relative',
        }}>
          <img src={backgroundImage} alt="Background" style={{ width: '100%', height: '100%' }} />
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))`
          }} />
        </Box>
      </Box>
    );
  }
  // Customizable Area End
}

// Customizable Area Start
const webStyle = {
  // custom style definitions
};
// Customizable Area End
